module.exports = __webpack_public_path__ + "img/icon-signin.e1eb15ac.svg";